/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { useQuery, gql } from '@apollo/client';

export const useMe = ({ skip }) => {
    const ME_QUERY = gql`
    query CusName {
        me {
            id
            email
            username
        }
    }
    `;
  const { loading, error, data } = useQuery(ME_QUERY, {skip, context:{
    clientName:"/user-details"
  }});
  return { loading, error, data };
};